module.exports = __webpack_public_path__ + "static/media/pinpaiBuss.b6fc817d.svg";